import { StayingGuestType } from 'services/api/type/report.type';

export type StayingGuestXmlMissingField =
  | 'temporary_residence_until'
  | 'nationality'
  | 'identification';

export type StayingGuestXmlValidationIssue = {
  row: StayingGuestType;
  missingFields: StayingGuestXmlMissingField[];
};

export const STAYING_GUEST_XML_FIELD_LABELS: Record<StayingGuestXmlMissingField, string> = {
  temporary_residence_until: 'Temporary stay until',
  nationality: 'Nationality',
  identification: 'ID document'
};

/** Odoo may return `false` for empty optional string/date fields. */
export function asTrimmedString(value: unknown): string {
  if (value == null || value === false) return '';
  if (typeof value === 'string') return value.trim();
  return String(value).trim();
}

export function isVietnameseGuest(row: StayingGuestType): boolean {
  const name = asTrimmedString(row.country?.name).toLowerCase();
  const iso = asTrimmedString(row.country?.iso_code).toUpperCase();
  return name === 'vietnam' || iso === 'VN' || iso === 'VNM';
}

export function getStayingGuestXmlMissingFields(
  row: StayingGuestType
): StayingGuestXmlMissingField[] {
  const missing: StayingGuestXmlMissingField[] = [];
  if (!asTrimmedString(row.thoi_han_luu_tru) && !isVietnameseGuest(row)) {
    missing.push('temporary_residence_until');
  }
  if (!asTrimmedString(row.country?.name)) {
    missing.push('nationality');
  }
  if (!asTrimmedString(row.identification)) {
    missing.push('identification');
  }
  return missing;
}

export function validateStayingGuestsXmlExport(rows: StayingGuestType[]) {
  const issues: StayingGuestXmlValidationIssue[] = rows
    .map(row => ({ row, missingFields: getStayingGuestXmlMissingFields(row) }))
    .filter(issue => issue.missingFields.length > 0);
  return { ok: issues.length === 0, issues, total: rows.length };
}
